import React from 'react';

import { type MessageBoxProps, MessageBox } from '@europrocurement/flexy-components';

import { useUser } from '../../../../Utilisateur/hooks/useUser';

export type AuthenticatedMessageBoxProps = MessageBoxProps & {};

const AuthenticatedMessageBox: React.FunctionComponent<AuthenticatedMessageBoxProps> = function ({
    destinataire,
    messages,
    ...othersMessageBoxProps
}) {
    const { fetchUser, cache } = useUser();

    // Cache des promises pour get les infos des Users KC
    const userIdentifiers = React.useMemo(
        () => Array.from(new Set(messages.map((m) => m.data.userIdentifier))),
        [messages],
    );

    // Ajout du user dans le bandeau
    if (destinataire?.userIdentifier && !userIdentifiers.includes(destinataire?.userIdentifier)) {
        userIdentifiers.push(destinataire?.userIdentifier);
    }

    React.useEffect(() => {
        userIdentifiers.forEach((userIdentifierInCache) => {
            if (!cache[userIdentifierInCache] && cache[userIdentifierInCache] !== null) {
                fetchUser(userIdentifierInCache);
            }
        });
    }, [userIdentifiers, fetchUser, cache]);

    return (
        <MessageBox
            destinataire={destinataire}
            messages={messages}
            userMapping={cache}
            {...othersMessageBoxProps}
        />
    );
};

export default AuthenticatedMessageBox;
